import { render, staticRenderFns } from "./ResultSharingDetail.vue?vue&type=template&id=5780b53d"
import script from "./ResultSharingDetail.vue?vue&type=script&lang=js"
export * from "./ResultSharingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports